import { Component, OnInit } from '@angular/core';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

@Component({
  selector: 'dm-feed-main',
  templateUrl: './feed-main.component.html',
  styleUrls: ['./feed-main.component.css']
})
export class FeedMainComponent implements OnInit {
  error: any;

  constructor(private errorManager: ErrorManagerService) { }

  ngOnInit() {
    this.clearError();

    if (this.errorManager.dataMinerUiErrorsObservable) {
      this.errorManager.dataMinerUiErrorsObservable.subscribe(
        error => {
            this.error = error;
        }
      );
    }
  }

  clearError() {
    this.errorManager.removeDataMinerUiError(this.errorManager.errorFeedsListKey, 'feed-list');
  }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-main/feed-main.component.ts